/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Cta_PrimaryInputs */

const en_mk_tut_cta_primary = /** @type {(inputs: Mk_Tut_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free now`)
};

const id_mk_tut_cta_primary = /** @type {(inputs: Mk_Tut_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba gratis sekarang`)
};

/**
* | output |
* | --- |
* | "Start free now" |
*
* @param {Mk_Tut_Cta_PrimaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_cta_primary = /** @type {((inputs?: Mk_Tut_Cta_PrimaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Cta_PrimaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_cta_primary(inputs)
	return en_mk_tut_cta_primary(inputs)
});